/**
 * @returns {String}
 */
export default function getEnvironment() {
  if (process.env.GOVLAUNCH_ENV) {
    return process.env.GOVLAUNCH_ENV;
  } else if (process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  } else {
    return "development";
  }
}
